import { Component, ViewChild, OnInit, EventEmitter, ChangeDetectorRef} from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { ProjectsService } from '../projects/projects.service';
import { ProjectDataService } from '../shared/dataservice.service';
import { UploadService } from '../shared/upload.service';
import { SharedService } from '../shared/shared.service';
import * as globals from '../globals';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import * as Materialize from 'angular2-materialize/dist/index';
import { DropzoneWorkspaceComponent } from '../dropzone/dropzone-workspace.component';
import { DropzoneAttachComponent } from '../dropzone/dropzone-attach.component';
import { UtilsService } from '../shared/utils.service';
import { GetFileTypeService } from '../shared/getFileType/get-file-type.service';
import { NavbarService } from '../navbar/navbar.service';
import { S3CredService } from '../shared/s3-cred-service';
import { ShareModelComponent } from '../sharemodel/sharemodel.component';
import { TranslateModelComponent } from '../translatemodel/translatemodel.component';
import { UploadModelComponent } from '../uploadmodel/uploadmodel.component';
import { UploadModelService } from '../uploadmodel/uploadmodel.service';
import { DeleteModelComponent } from '../deletemodel/deletemodel.component';
declare var openNewBrowserWindow: any;
declare var jQuery: any;

@Component({
  selector: 'app-workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.css'],
  providers: [ GetFileTypeService, S3CredService, TranslateModelComponent, UploadModelService]
})
export class WorkspaceComponent implements OnInit {

  models = [];
  dupnames = [];
  dupnumbers = [];
  dupfilenames = [];
  myProjects = [];
  bucketname = globals.BUCKETNAME;
  tenantid: string = '';
  planid: string;
  _service: any;
  _projectDataService: any;
  errorMessage: string;
  email = '';
  loadingmodels: boolean = true;
  loadingmyprojects: boolean = true;
  uploadingproject: boolean = false;
  uploadingModel: boolean = false;
  progressbarActive: boolean = false;
  projectloaderror: boolean = false;
  tenanturl: string = '';
  filesToUpload: Array<File>;
  createicon = '';
  createanywayicon = '';
  createanyway2icon = '';
  deleteSpinnerIcon = '';

  usagesize: number = 0;
  usagesizestr: string = '';
  usagesizepercentage: string = '';
  usagecount: number = 0;
  usagecountpercentage: string = '';
  oversizelimit: boolean = false;
  overcountlimit: boolean = false;
  noProjects: boolean;
  uploadprojectTabOn = false;
  ContextOwnerID: number = 0;

  selectedmaterial: string;
  materialselect: number;
  selectedassignee: string;
  selectedcustomer: string;
  customerselect: number;
  public filteredMaterialList = [];
  public filteredCustomerList = [];
  public filteredOwnerList = [];
  public elementRef;
  materialArray: any = [];
  materialDict: any = {};
  ownerArray: any = [];
  ownerDict: any = {};
  customerArray: any = [];
  customerDict: any = {};
  statusArray: any = ['OPEN', 'WIP', 'REVIEW', 'APPROVED', 'MADE'];
  modelToDelete: any = [];
  ModelToProject: any = [];

  translatemodelid: string = '';
  translatename: string = '';
  translatefilename: string = '';
  translatetype: string = 'stp';
  // 0=loading, 1=file not present, 2=file present
  translatePDF: number = 0;
  translateSTP: number = 0;
  translateSTL: number = 0;
  isProcessingCount: number = 0;
  processingtry: number = 0;
  translatetimer: any;
  translatetimerlength: number = 10000;
  uploadCurrentValue: number;
  createButtonStatus: boolean = true;
  public progresses: any = [];

  sharelink: string = '';
  sharefolder: string = '';
  sharefilename: string = '';
  sharemodelid: string = '';
  shareemail: string = '';
  sharesubject: string = '';
  sharemessage: string = '';
  shareErrorMessage: string = '';
  linkchars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  timer: any;
  timerlength: number = 10000;

  uploadTabOn: any = false;

  // Pagination
  public filter: string = '';
  public filter1: string = '';
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public config = {
    itemsPerPage: 25,
    currentPage: 1,
    totalItems: 1
  };
  public projectconfig = {
    itemsPerPage: 25,
    projectcurrentPage: 1,
    projecttotalItems: 1
  };
  public searchTerms: any;
  public searchOwnerTerms: any;
  duplicateFilename: boolean = false;
  duplicateName: boolean = false;
  duplicateNumber: boolean = false;
  confirmed: boolean = false;
  showUploadButton: boolean = false;
  disableUploadButton: boolean = true;
  uploadfilebtnstatus: boolean = true;
  public dateFormat: string;

  // create project
  projectname: string = '';
  partnumber: string = '';
  revision: string = '';
  projectdescription: string;

  modalModel2ProjectAction = new EventEmitter<string | MaterializeAction>();
  modalShowTranslateAction = new EventEmitter<string | MaterializeAction>();
  modalcreateProjectConfirmAction = new EventEmitter<string | MaterializeAction>();

  @ViewChild(DropzoneWorkspaceComponent) _dropzoneWorkspace: DropzoneWorkspaceComponent;
  @ViewChild(DropzoneAttachComponent) _dropzoneattach: DropzoneAttachComponent;
  @ViewChild('uploadmodel') uploadmodel;

  constructor(private router: Router,
    private http: Http, private service: SharedService,
    private projectService: ProjectsService,
    private projectDataService: ProjectDataService,
    private uploadService: UploadService,
    private utilsService: UtilsService,
    private getFileTypeService: GetFileTypeService,
    private translateModel: TranslateModelComponent,
    public navService: NavbarService,
    private cdRef: ChangeDetectorRef,
    public s3CredService: S3CredService,
    private uploadModelService: UploadModelService
  ) {
    this._service = service;
    this._projectDataService = projectDataService;
    console.log('SERVICE:', service);
  }

  ngOnDestroy() {
    this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
    this.modalShowTranslateAction.emit({ action: 'modal', params: ['close'] });
    this.modalcreateProjectConfirmAction.emit({ action: 'modal', params: ['close'] });
  }

  ngOnInit() {
    this.navService.show('MY WORKSPACE');
    this.navService.setNavID(0);
    this.planid = localStorage.getItem('mr_planid');
    this.dateFormat = localStorage.getItem('mr_date_format_id');
    if (typeof this.planid == 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    this.tenantid = localStorage.getItem('mr_tenantid');
    this.email = localStorage.getItem('mr_email');
    this.planid = localStorage.getItem('mr_planid');
    this.loadingmodels = true;

    if (typeof this.planid == 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    if (this.planid === '3') {
      this.tenanturl = globals.GOVTENANTURL;
    } else {
      this.tenanturl = globals.TENANTURL;
    }

    console.log('TENANTURL:', this.tenanturl);
    console.log('EMAIL:', this.email);
    this.noProjects = false;

    this.loadWorkspace();
  }

  // Added this beecause Angular was complaining about values changing after ngInit
  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  loadWorkspace() {
    this.projectService.getProjects(true,
      this.config.currentPage,
      this.config.itemsPerPage,
      globals.ProjectType.WORKSPACE,
      this.searchTerms)
    // this.workspaceService.getWorkspace()
    .subscribe(
      data => {
        console.log('Got projects');
        // console.log('PROJECTS data:', data);
        if (Object.keys(data).length === 0) {
          // Credential ERROR
          // this.credentialerror = true;
          this.loadingmodels = false;
          this.projectloaderror = true;
        } else {
          // TODO: Account for a response of 'Process exited before completing request'
          //      or have API Gateway massage this response
          let projectdata = JSON.parse(data);

          this.config.currentPage = Number(projectdata.pagenum);
          this.config.totalItems = projectdata.count;

          if (!projectdata.projects.length) {
            this.noProjects = true;
          } else {

          }
          this.refreshModels(data);
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjects() error:', this.errorMessage);
        this.loadingmodels = false;
        this.projectloaderror = true;
      }
    );
  }

  refreshModels(data) {
    let projectdata = JSON.parse(data);
    console.log('refreshModels');
    console.log(projectdata);

    let isProcessing = false;

    // Populate the thumbnail URLs
    for (let key in projectdata.projects) {
      // Determine the status of the model file to show
      if (projectdata.projects.hasOwnProperty(key)) {
        if (projectdata.projects[key].upload_status == 1) {
          isProcessing = true;
        }

        // Get the filename extension
        projectdata.projects[key].extension = projectdata.projects[key].filename.split('.').pop();

        // Get the filename without the extension
        let filenamenoext = projectdata.projects[key].filename.replace(/\.[^/.]+$/, '');
        if (!filenamenoext) {
          filenamenoext = ' ';
        }
        filenamenoext = filenamenoext.replace(/[+]/g, '%2B');

        if (projectdata.projects[key].material_id == null || projectdata.projects[key].material_id == 'undefined') {
          projectdata.projects[key].material_id = 0;
        }
        // projectdata.projects[key].material_id = 0; // Testing of material
        // projectdata.projects[key].assigned_id = 0;
        // projectdata.projects[key].customer_id = 0;
        projectdata.projects[key].status_id = 0;
        projectdata.projects[key].filenamenoext = filenamenoext;

        let modeltype = this.utilsService.determineModelType(projectdata.projects[key].filename);

        if (projectdata.projects[key].modeltype_id == 0 && modeltype != 0) {
          projectdata.projects[key].modeltype_id = modeltype;
        }

        if (modeltype != 0) {
          projectdata.projects[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + projectdata.projects[key].id + '/' + filenamenoext + '_320x240.png';
        } else {
          let ext = projectdata.projects[key].extension.toLowerCase();
          console.log('EXTENSION:', ext);
          if (ext === 'pdf') {
            projectdata.projects[key].thumbnail = '/assets/images/doctypes/pdf96.png';
          } else if (ext === 'doc' || ext === 'docx') {
            projectdata.projects[key].thumbnail = '/assets/images/doctypes/doc96.png';
          } else if (ext === 'xls' || ext === 'xlsx') {
            projectdata.projects[key].thumbnail = '/assets/images/doctypes/xls96.png';
          } else if (ext === 'ppt' || ext === 'pptx') {
            projectdata.projects[key].thumbnail = '/assets/images/doctypes/ppt96.png';
          } else if (ext === 'gif' || ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'tiff' || ext === 'tif') {
            projectdata.projects[key].thumbnail = '/assets/images/doctypes/img96.png';
          } else if (ext === 'iso' || ext === 'tar' || ext === 'gz' || ext === '7z' || ext === 'cab' || ext === 'rar' || ext === 'sit' || ext === 'tar' || ext === 'zip') {
            projectdata.projects[key].thumbnail = '/assets/images/doctypes/zip.png';
          } else {
            projectdata.projects[key].thumbnail = '/assets/images/doctypes/file96.png';
          }
        }

        let val = projectdata.projects[key];
        // console.log(val);
      }

      // Determine the Part Type to show
      projectdata.projects[key].cardparttype = this.utilsService.getModelName(projectdata.projects[key].modeltype_id);

      this.models = projectdata.projects;
    }

    if (this.planid !== '1') {
      this.materialArray = projectdata.materials;
      this.ownerArray = projectdata.owners;
      this.customerArray = projectdata.customers;

      if (this.materialArray) {
        for (let i = 0; i < this.materialArray.length; i++) {
          this.materialDict[this.materialArray[i].id] = this.materialArray[i].name;
        }
      }

      if (this.ownerArray) {
        for (let i = 0; i < this.ownerArray.length; i++) {
          this.ownerDict[this.ownerArray[i].id] = this.ownerArray[i].email;
          if (this.email === this.ownerArray[i].email) {
            this.ContextOwnerID = this.ownerArray[i].id;
          }
        }
      }

      if (this.customerArray) {
        for (let i = 0; i < this.customerArray.length; i++) {
          this.customerDict[this.customerArray[i].id] = this.customerArray[i].name;
        }
      }

      console.log('Materials:', this.materialArray);
      console.log('Owners:', this.ownerArray);
      console.log('Customers:', this.customerArray);
    }

    this.loadingmodels = false;

    // See if any of the projects are in a processing state.  If so
    // start a timer to check the backend for them to be completed.
    if (isProcessing) {
      console.log('Detected a project in the processing state');
      this.timer = Observable.timer(this.timerlength);
      this.timer.subscribe(t => this.checkProcessingStatus());
    }
  }


  onModelPageChange(number: number) {
    console.log('change to page', number);
    this.config.currentPage = number;
    this.loadingmodels = true;
    this.models = [];

    this.projectService.getProjects(true,
      this.config.currentPage,
      this.config.itemsPerPage,
      globals.ProjectType.WORKSPACE,
      this.searchTerms)
    // this.workspaceService.getWorkspace()
    .subscribe(
      data => {
        console.log('Got projects');
        // console.log('PROJECTS data:', data);
        if (Object.keys(data).length === 0) {
          // Credential ERROR
          // this.credentialerror = true;
          this.loadingmodels = false;
          this.projectloaderror = true;
        } else {
          // TODO: Account for a response of 'Process exited before completing request'
          //      or have API Gateway massage this response
          let projectdata = JSON.parse(data);

          this.config.currentPage = Number(projectdata.pagenum);
          this.config.totalItems = projectdata.count;

          this.refreshModels(data);
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjects() error:', this.errorMessage);
        this.loadingmodels = false;
        this.projectloaderror = true;
      }
    );
  }

  openInViewer(id: string, name: string) {
    // Build the URL
    let hwfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + name + '.hwf';

    console.log('openInViewer() URL: ', hwfurl);
    localStorage.setItem('hwfurl', hwfurl);
    // this.router.navigate(['/viewer']);
    openNewBrowserWindow('/#/viewer', hwfurl);
  }

  OpenPDFView(project) {
    let PDFurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + project.id + '/' + project.name + '.pdf';
    // localStorage.setItem('saved_pdfurl', PDFurl);
    // window.open('/#/pdfviewer');
    // this.router.navigate(['/pdfviewer']);
    // window.open(PDFurl, '_blank');

    var myNewTab = window.open();
    
    this.projectService.downloadPDF(PDFurl).subscribe(
      (res) => {
        let fileURL = URL.createObjectURL(res);
        myNewTab.location.href = fileURL;
        // window.open(fileURL);
      }
    );
  }

  onDownloadNonCADFile(id: string, filename: string) {
    let url = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + filename;
    console.log('URL:', url);
    window.open(url);
  }

  checkProcessingStatus() {
    let processingCount;
    this.uploadModelService.processingUploadCheck()
    .subscribe(
      data => {
        // console.log('checkProcessingStatus data:', data);
        console.log('checkProcessingStatus');
        let processingdata = JSON.parse(data);
        processingCount = processingdata.length;
        this.processingtry++;
        console.log('processingCount = ', processingCount);
        if (processingdata.length == 0 || processingCount < this.isProcessingCount || this.processingtry > 5) {
          // No projects processing, so refresh the data
          console.log('No projects in a processing state');
          // this.projectsService.getProjects()
          this.projectService.getProjects(true,
            this.config.currentPage,
            this.config.itemsPerPage,
            globals.ProjectType.WORKSPACE,
            this.searchTerms)
          .subscribe(
            data => {
              console.log('Got projects');
              // console.log('PROJECTS data:', data);
              if (Object.keys(data).length === 0) {
                // Credential ERROR
                // this.credentialerror = true;
                this.loadingmodels = false;
                this.projectloaderror = true;
              } else {
                // TODO: Account for a response of 'Process exited before completing request'
                //      or have API Gateway massage this response
                let workspacedata = JSON.parse(data);

                this.config.currentPage = Number(workspacedata.pagenum);
                this.config.totalItems = workspacedata.count;

                this.refreshModels(data);

              }
            },
            error => {
              this.errorMessage = <any>error;
              console.error('getProjects() error:', this.errorMessage);
              this.loadingmodels = false;
              // this.projectloaderror = true;
            }
          );
        } else {
          // Start the timer again
          console.log('Project(s) are in a processing state');
          this.isProcessingCount = processingCount;
          this.timer = Observable.timer(this.timerlength);
          this.timer.subscribe(t => this.checkProcessingStatus());
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('checkProcessingStatus() error:', this.errorMessage);
      }
    );
  }

  onModelDelete() {
    window.location.reload();
  }

  onProjectUpload() {
    // super temporary hack delay to reload page to allow recipe to be created. Will be fixed after syncing Project page's in page refresh process
    let timer = Observable.timer(750);
    timer.subscribe(t => {
      window.location.reload();
    });
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/workspace/workspace.component.ts